export default {"src":"/evde-internet/_next/static/media/left-confeti.7c31deba.svg","height":128,"width":169};